import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'
import '@/utils/validate'
import '@/assets/svg-icon'
import 'mand-mobile/components/_style/global.styl'
import VuePageStack from 'vue-page-stack'
import i18n, { loadLanguageAsync } from './lang/index'
import '@/utils/directive'// 自定义指令
// import VConsole from 'vconsole'
// // eslint-disable-next-line no-new
// new VConsole()

Vue.use(VuePageStack, { router, keyName: 'k' })

loadLanguageAsync().then(() => {
  Vue.config.productionTip = false
  const app = new Vue({
    name: 'App',
    router,
    store,
    i18n,
    render: h => h(App)
  })
  app.$mount('#app')
})
